import joint from "rappid";
import "rappid/dist/rappid.min.css";
import "./css/theme-picker.css";
import "./css/style.css";
import "./css/style.dark.css";
import "./css/style.modern.css";
import "./css/style.material.css";

import "./config/halo";
import "./config/selection";
import "./config/inspector";
import "./config/stencil";
import "./config/toolbar";
import "./config/sample-graphs";
import "./views/main";
import "./views/theme-picker";
import "./models/joint.shapes.app";

import App from "./App";

export default App;